import { render, staticRenderFns } from "./FinishRegister.vue?vue&type=template&id=bfda4e8a&"
import script from "./FinishRegister.vue?vue&type=script&lang=js&"
export * from "./FinishRegister.vue?vue&type=script&lang=js&"
import style0 from "./FinishRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports